import React from "react";
import { Modal, Spinner } from "react-bootstrap";

const DeleteModal = (props) => {
  return (
    <Modal
      {...props}
      className="delete-popup"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Are you sure you want to delete this deal?</h4>
        <div className="button-row">
          <button className="cancel-btn" onClick={props.onHide}>
            Cancel
          </button>
          <div
            onClick={() => props.deleteEventHandler(props.id)}
            className="button"
            style={{ cursor: "pointer" }}
          >
            {props.deleteLoading ? (
              <Spinner
                className="spinner"
                animation="border"
                role="status"
                style={{ height: "20px", width: "20px" }}
              >
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              "Yes"
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
